module.exports = __webpack_public_path__ + "static/img/trumpet.458c2654.svg";